import { render, staticRenderFns } from "./educationHome.vue?vue&type=template&id=6bf855de&scoped=true"
import script from "./educationHome.vue?vue&type=script&lang=js"
export * from "./educationHome.vue?vue&type=script&lang=js"
import style0 from "./educationHome.vue?vue&type=style&index=0&id=6bf855de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf855de",
  null
  
)

export default component.exports